export default "__VITE_ASSET__DtA27amT__"